export function FinalRewardFrameGeneral(props: { colors?: [string, string] }) {
  const [color0, color1] = props.colors ?? ['#66d58d', '#f6f396']
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="113"
      height="104"
      fill="none"
      className="relative -left-2"
    >
      <mask id="final-reward-frame-general-c" fill="#fff">
        <path d="M61 0c17.9 0 26.9 0 33.7 3.5 6 3 11 8 14 14 3.5 6.8 3.5 15.8 3.5 33.7v1.6c0 18 0 26.9-3.5 33.7-3 6-8 11-14 14C87.9 104 78.9 104 61 104h-1.6c-18 0-27 0-33.8-3.5-6-3-10.9-8-14-14-1.9-3.8-2.8-8.3-3.1-14.7-.2-3.1-.3-4.7-.5-5.8-.6-3.6-1.8-6.2-4-9-.8-1-1.7-1.8-3.4-3.6a2 2 0 0 1 0-2.8L3.9 47C6.2 44.2 7.4 41.6 8 38c.2-1.1.3-2.7.5-5.8.3-6.4 1.2-10.9 3.2-14.7 3-6 8-11 14-14C32.4 0 41.4 0 59.3 0z" />
      </mask>
      <path
        fill="url(#final-reward-frame-general-a)"
        d="M61 0c17.9 0 26.9 0 33.7 3.5 6 3 11 8 14 14 3.5 6.8 3.5 15.8 3.5 33.7v1.6c0 18 0 26.9-3.5 33.7-3 6-8 11-14 14C87.9 104 78.9 104 61 104h-1.6c-18 0-27 0-33.8-3.5-6-3-10.9-8-14-14-1.9-3.8-2.8-8.3-3.1-14.7-.2-3.1-.3-4.7-.5-5.8-.6-3.6-1.8-6.2-4-9-.8-1-1.7-1.8-3.4-3.6a2 2 0 0 1 0-2.8L3.9 47C6.2 44.2 7.4 41.6 8 38c.2-1.1.3-2.7.5-5.8.3-6.4 1.2-10.9 3.2-14.7 3-6 8-11 14-14C32.4 0 41.4 0 59.3 0z"
      />
      <path
        fill="url(#final-reward-frame-general-b)"
        fillOpacity=".2"
        d="m94.7 3.5 1-1.8zm14 14 1.8-1zm0 69 1.8 1zm-14 14 1 1.8zm-69 0-1 1.8zm-14-14-1.8 1zM.6 53.5l-1.4 1.3zm0-3L2 52zm11-33-1.7-1zm14-14-.9-1.8zM4 47l-1.5-1.3zm4.6-14.9h-2zM8 38l2 .3zm0 28-2 .3zm-4-9-1.6 1.2zM61 0v2c9 0 15.6 0 20.8.4s8.9 1.3 12 2.9l.9-1.8 1-1.8c-3.8-2-8-2.8-13.5-3.3S69.9-2 61-2zm33.7 3.5-1 1.8a30 30 0 0 1 13.2 13l1.8-.8 1.8-1A34 34 0 0 0 95.6 1.8zm14 14-1.8.9c1.6 3 2.4 6.7 2.8 12 .5 5.2.5 11.8.5 20.8h4c0-9 0-15.7-.5-21.2q-.5-8-3.2-13.4zm3.5 33.7h-2v1.6h4v-1.6zm0 1.6h-2c0 9 0 15.6-.5 20.9s-1.2 8.8-2.8 12l1.8.8 1.8 1c1.9-3.8 2.8-8 3.2-13.5s.5-12.3.5-21.2zm-3.5 33.7-1.8-.9a30 30 0 0 1-13.1 13.1l.9 1.8 1 1.8a34 34 0 0 0 14.8-14.9zm-14 14-1-1.8q-4.3 2.3-11.9 2.9c-5.2.4-11.8.4-20.8.4v4c8.9 0 15.7 0 21.2-.4q8-.6 13.4-3.3zM61 104v-2h-1.6v4H61zm-1.6 0v-2c-9 0-15.6 0-20.9-.4s-8.9-1.3-12-2.9l-.9 1.8-.9 1.8c3.8 2 8 2.8 13.5 3.3q7.9.5 21.2.4zm-33.8-3.5 1-1.8a30 30 0 0 1-13.2-13l-1.7.8-1.8 1a34 34 0 0 0 14.8 14.8zm-14-14 1.8-.9a35 35 0 0 1-3-14l-2 .2h-2C7 78.5 7.8 83.3 10 87.5zm-11-33L2 52 .6 50.6l-1.4-1.4a4 4 0 0 0 0 5.6zm7.9-21.3 2 .1c.3-6.3 1.2-10.4 3-14l-1.8-.8-1.8-1c-2.2 4.3-3 9.1-3.4 15.6zm3.2-14.7 1.7.9A30 30 0 0 1 26.6 5.3l-1-1.8-.9-1.8A34 34 0 0 0 10 16.6zm14-14 .9 1.8c3-1.6 6.7-2.4 12-2.9S50.3 2 59.3 2v-4q-13.3-.1-21.2.4c-5.5.5-9.7 1.4-13.5 3.3zM59.3 0v2H61v-4h-1.6zM.6 50.6 2 52q2.4-2.4 3.5-3.7l-1.6-1.2-1.5-1.3-3.2 3.4zm7.9-18.4h-2c-.2 3-.3 4.5-.5 5.5l2 .3 2 .3.5-6zM3.9 47.1l1.6 1.2c2.5-3 3.8-6 4.5-10L8 38l-2-.3c-.5 3.2-1.6 5.6-3.6 8.1zm4.6 24.7 2-.1-.5-6-2 .3-2 .3c.2 1 .3 2.4.5 5.6zm-8-18.4-1.3 1.4 3.2 3.4 1.5-1.3 1.6-1.2Q4.5 54.4 2 52zM8 66l2-.3c-.7-4-2-7-4.5-10l-1.6 1.2-1.5 1.3q2.9 3.6 3.6 8.1z"
        mask="url(#final-reward-frame-general-c)"
      />
      <defs>
        <linearGradient
          id="final-reward-frame-general-a"
          x1="57"
          x2="57"
          y1="0"
          y2="104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color0} />
          <stop offset="1" stopColor={color1} />
        </linearGradient>
        <linearGradient
          id="final-reward-frame-general-b"
          x1="51.6"
          x2="51.6"
          y1="0"
          y2="104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity=".2" />
        </linearGradient>
      </defs>
    </svg>
  )
}
